import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledProductsList,
  StyledButton,
  StyledMessage,
} from './ProductsList.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'

const NOT_FOUND_MESSAGE =
  'Sorry, we could not find any results for your search. Please double check your spelling, try different keywords, or clear your filters.'

const ProductsList = (props) => {
  const { isOurProducts, products } = props

  const productsList = products.map((product) => (
    <StyledButton
      key={product.sys.id}
      label={product.fields.title}
      variant={ButtonVariantEnum.tertiary}
      to={`/${product.fields.slug}`}
    />
  ))

  return (
    <StyledProductsList isOurProducts={isOurProducts}>
      {products.length === 0 ? (
        <StyledMessage>{NOT_FOUND_MESSAGE}</StyledMessage>
      ) : (
        productsList
      )}
    </StyledProductsList>
  )
}

ProductsList.propTypes = {
  isOurProducts: PropTypes.bool.isRequired,
  products: PropTypes.array,
}

export default ProductsList
